const translations = {
    firstName: 'First Name',
    lastName: 'Last Name',
    phoneNumber: 'Phone Number (optional)'
};

export default translations;
